import { IDjangoApi1License } from '../../tn.common';

export function hasSelfHostedLicenseList(
    licenses: IDjangoApi1License[]
): IDjangoApi1License[] {
    return licenses.filter((license) => {
        return (
            license.fontRights.web &&
            license.fontRights.web.qty &&
            license.fontRights.web.self_hosted
        );
    });
}
